"use strict";

exports.__esModule = true;
var _titleOptions = require("./titleOptions");
Object.keys(_titleOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _titleOptions[key]) return;
  exports[key] = _titleOptions[key];
});
var _gridOptions = require("./gridOptions");
Object.keys(_gridOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _gridOptions[key]) return;
  exports[key] = _gridOptions[key];
});
var _toolboxOptions = require("./toolboxOptions");
Object.keys(_toolboxOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _toolboxOptions[key]) return;
  exports[key] = _toolboxOptions[key];
});
var _visualMapOptions = require("./visualMapOptions");
Object.keys(_visualMapOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _visualMapOptions[key]) return;
  exports[key] = _visualMapOptions[key];
});
var _axisOptions = require("./axisOptions");
Object.keys(_axisOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _axisOptions[key]) return;
  exports[key] = _axisOptions[key];
});
var _markLinesOptions = require("./markLinesOptions");
Object.keys(_markLinesOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _markLinesOptions[key]) return;
  exports[key] = _markLinesOptions[key];
});
var _statisticsPointsOptions = require("./statisticsPointsOptions");
Object.keys(_statisticsPointsOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _statisticsPointsOptions[key]) return;
  exports[key] = _statisticsPointsOptions[key];
});